import { render, staticRenderFns } from "./CengageUnlimitedCarousel.vue?vue&type=template&id=f53f3dc8&scoped=true&"
import script from "./CengageUnlimitedCarousel.vue?vue&type=script&lang=js&"
export * from "./CengageUnlimitedCarousel.vue?vue&type=script&lang=js&"
import style0 from "./CengageUnlimitedCarousel.vue?vue&type=style&index=0&id=f53f3dc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53f3dc8",
  null
  
)

export default component.exports